<template>
  <v-container>
    <h3>グラフ表示テンプレート</h3>

    <v-container class="mx-n2 mt-4">
      <h4>インポート</h4>
      <v-divider class="my-2"></v-divider>

      <p class="px-1 py-2">サーバーに登録されているテンプレートを、ご利用中の端末に読み込みます。</p>

      <v-row class="mt-1">
        <v-col cols="12" class="my-2" v-if="isShowImportCompleteMessage">
          <v-alert variant="tonal" type="success" v-model="isShowImportCompleteMessage" closable>インポートしました</v-alert>
        </v-col>

        <v-col :cols="$vuetify.display.mobile ? 12 : 6" class="d-flex align-center">
          <div>
            <v-label class="ms-2 text-subtitle-2">テンプレート：</v-label>
            <span class="ms-2">{{ (template.length == 0) ? 'なし' : 'あり' }}</span>
          </div>
        </v-col>

        <v-col :cols="$vuetify.display.mobile ? 12 : 6" class="d-flex justify-end">
          <v-btn variant="outlined" color="primary" :disabled="(template.length == 0)"
            v-on:click="isShowImportConfirmDialog = true;">インポート</v-btn>
        </v-col>
      </v-row>

    </v-container>

    <v-container class="mx-n2 mt-4">
      <h4>テンプレート登録</h4>
      <v-divider class="my-2"></v-divider>

      <p class="px-1 py-2">ご利用中の端末の現在のグラフ表示設定を、テンプレートとしてサーバーに登録します。</p>

      <v-row class="mt-1">
        <v-col cols="12" class="my-2" v-if="isShowSaveCompleteMessage">
          <v-alert variant="tonal" type="success" v-model="isShowSaveCompleteMessage" closable>登録しました</v-alert>
        </v-col>

        <v-col :cols="$vuetify.display.mobile ? 12 : 10" class="d-flex align-center">
          <p class="text-error" v-if="localSetting.length <= 2">
            テンプレートとして登録するには、グラフを1つ以上追加してください
          </p>
        </v-col>

        <v-col :cols="$vuetify.display.mobile ? 12 : 2" class="d-flex justify-end">
          <v-btn elevation="0" color="primary" :disabled="(localSetting.length <= 2)"
            :loading="isPutLoading" v-on:click="isShowSaveConfirmDialog = true;">登録する</v-btn>
        </v-col>
      </v-row>

    </v-container>

    <v-dialog max-width="400" v-model="isShowImportConfirmDialog">
      <v-card>
        <v-card-text>
          ご利用中の端末の現在の設定は削除されます。よろしいですか？
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowImportConfirmDialog = false;">
            キャンセル
          </v-btn>
          <v-btn color="primary" v-on:click="isShowImportConfirmDialog = false; importTemplate();">
            インポート
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="400" v-model="isShowSaveConfirmDialog">
      <v-card>
        <v-card-text>
          {{ (template.length == 0) ? 'サーバーにテンプレートを登録し' : 'サーバーに登録されているテンプレートが上書きされ' }}ます。よろしいですか？
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn v-on:click="isShowSaveConfirmDialog = false;">
            キャンセル
          </v-btn>
          <v-btn color="primary" v-on:click="isShowSaveConfirmDialog = false; putTemplate();">
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default defineComponent({
  name: 'ChartViewTemplateSetting',

  setup() {

    const template = ref('');

    const localSetting = ref('');


    const isShowImportConfirmDialog = ref(false);

    const isShowImportCompleteMessage = ref(false);


    const isShowSaveConfirmDialog = ref(false);

    const isPutLoading = ref(false);

    const isShowSaveCompleteMessage = ref(false);


    onMounted(() => {

      const chartAreasSetting = window.localStorage.getItem('chart-areas-setting');
      if (chartAreasSetting != null) {
        localSetting.value = chartAreasSetting;
      }

      fetchTemplate();

    });

    const fetchTemplate = () => {

      axios.get(
        config.API_URL +
        `/users/me/display-templates/chart-areas`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        if (response.data.json != null) {
          template.value = response.data.json;
        }

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    const importTemplate = () => {

      isShowSaveCompleteMessage.value = false;

      window.localStorage.setItem('chart-areas-setting', template.value);

      localSetting.value = template.value;

      isShowImportCompleteMessage.value = true;

    };


    const putTemplate = () => {

      isShowImportCompleteMessage.value = false;

      isPutLoading.value = true;
      isShowSaveCompleteMessage.value = false;

      const reqBody = {
        json: localSetting.value
      };

      axios.put(
        config.API_URL +
        `/users/me/display-templates/chart-areas`,
        reqBody,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem('access-token') } }
      ).then((/* response */) => {

        template.value = localSetting.value;

        isPutLoading.value = false;
        isShowSaveCompleteMessage.value = true;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };


    return {
      template,
      localSetting,

      isShowImportConfirmDialog,
      isShowImportCompleteMessage,

      isShowSaveConfirmDialog,
      isPutLoading,
      isShowSaveCompleteMessage,

      importTemplate,

      putTemplate
    }

  }
});
</script>
